export const schema = {
  displayName: "Prüfvermerk",
  table: [
    {
      field: "avt_aid",
      readonly: true,
      hideFromDetail: true,
      hideFromEditor: () => true,
    },
    {
      field: "avt_pruefvermerk",
      display: "Prüfvermerk",
      type: "textarea",
      rows: 5,
    },
  ],
};
